import {useMemo} from 'react';

import {useFacebookAccounts} from '../../../../../service/accounts/accounts-hook';

import {isBrandOnlyReviewsCatalogId} from './header-alert/header-alert-hook';

type UseFacebookCatalogLinksGateReturnType = {
    facebookAccountsProcessError: ReturnType<typeof useFacebookAccounts>['processError'];
    hasFacebookAccount: boolean;
    isFacebookAccountsInProgress: boolean;
    isFacebookCatalog: boolean;
    isFacebookNoAccountPlaceholderVisible: boolean;
    isLinksTableVisible: boolean;
};

export function useFacebookCatalogLinksGate(
    catalogId: number,
    isCatalogResolved: boolean
): UseFacebookCatalogLinksGateReturnType {
    const isFacebookCatalog = isBrandOnlyReviewsCatalogId(catalogId);

    const {
        result: facebookAccounts,
        isInProgress: isFacebookAccountsInProgress,
        processError: facebookAccountsProcessError,
    } = useFacebookAccounts({skip: !isFacebookCatalog});

    const hasFacebookAccount = (facebookAccounts?.length ?? 0) > 0;

    return useMemo<UseFacebookCatalogLinksGateReturnType>(
        () => ({
            facebookAccountsProcessError: isFacebookCatalog ? facebookAccountsProcessError : null,
            hasFacebookAccount,
            isFacebookAccountsInProgress: isFacebookCatalog && isFacebookAccountsInProgress,
            isFacebookCatalog,
            isFacebookNoAccountPlaceholderVisible:
                isFacebookCatalog &&
                !isFacebookAccountsInProgress &&
                !facebookAccountsProcessError &&
                !hasFacebookAccount,
            isLinksTableVisible: isCatalogResolved && (!isFacebookCatalog || hasFacebookAccount),
        }),
        [
            facebookAccountsProcessError,
            hasFacebookAccount,
            isCatalogResolved,
            isFacebookAccountsInProgress,
            isFacebookCatalog,
        ]
    );
}
